import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { mainActions } from "../../store";
import classes from "./RefineHistoryToolbar.module.css";

const RefineHistoryToolbar = ({ children, showHeading = true }) => {
  const dispatch = useDispatch();
  const canUndo = useSelector(state => state.refineHistory.enabled && state.refineHistory.past.length > 0);
  const canRedo = useSelector(state => state.refineHistory.enabled && state.refineHistory.future.length > 0);
  useEffect(() => {
    const onKeyDown = event => {
      if (event.defaultPrevented || event.isComposing || event.altKey || !(event.ctrlKey || event.metaKey)) return;
      if (event.target instanceof Element && event.target.closest("input, textarea, select, [contenteditable]")) return;
      const key = event.key.toLowerCase();
      const redo = (key === "z" && event.shiftKey) || (key === "y" && !event.shiftKey);
      if (key !== "z" && !redo) return;
      event.preventDefault();
      const chart = event.target instanceof Element && event.target.closest("[data-refine-card-id]");
      if (chart) {
        dispatch(redo ? mainActions.redoChart(chart.dataset.refineCardId) : mainActions.undoChart(chart.dataset.refineCardId));
        return;
      }
      if (redo ? canRedo : canUndo) dispatch(redo ? mainActions.redoRefine() : mainActions.undoRefine());
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [dispatch, canUndo, canRedo]);
  return <div className={classes.toolbar} role="group" aria-label="Page details history">
    {showHeading && <strong>Page details</strong>}
    <button type="button" disabled={!canUndo} onClick={() => dispatch(mainActions.undoRefine())}>Undo page edit</button>
    <button type="button" disabled={!canRedo} onClick={() => dispatch(mainActions.redoRefine())}>Redo page edit</button>
    {children}
    <span>Undo: Ctrl+Z · Redo: Ctrl+Shift+Z</span>
  </div>;
};

export default RefineHistoryToolbar;
